import { render, staticRenderFns } from "./WikiView.vue?vue&type=template&id=2693b3c4&scoped=true"
import script from "./WikiView.vue?vue&type=script&lang=js"
export * from "./WikiView.vue?vue&type=script&lang=js"
import style0 from "./WikiView.scss?vue&type=style&index=0&id=2693b3c4&prod&lang=scss&scoped=true&external"
import style1 from "./WikiViewEditor.scss?vue&type=style&index=1&id=2693b3c4&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2693b3c4",
  null
  
)

export default component.exports